import Image from '~/components/image/Image'
import {
  CC_AMEX_IMAGE_URL,
  CC_DINERS_IMAGE_URL,
  CC_DISCOVER_IMAGE_URL,
  CC_JCB_IMAGE_URL,
  CC_MASTER_IMAGE_URL,
  CC_VISA_IMAGE_URL,
} from '~/lib/constants/constants'
import { css } from '~/styled-system/css'

export function CardBrandList() {
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        columnGap: '2',
      })}
    >
      <Image src={CC_VISA_IMAGE_URL} width={37} height={24} alt="Visa" />
      {/* MasterCardロゴは左右に余白を含むためネガティブマージンで調整 */}
      <Image
        src={CC_MASTER_IMAGE_URL}
        width={31}
        height={24}
        alt="MasterCard"
        className={css({ mx: '[-4px]' })}
      />
      <Image src={CC_JCB_IMAGE_URL} width={32} height={24} alt="JCB" />
      <Image src={CC_DISCOVER_IMAGE_URL} width={38} height={24} alt="Discover" />
      <Image src={CC_AMEX_IMAGE_URL} width={24} height={24} alt="AmericanExpress" />
      <Image src={CC_DINERS_IMAGE_URL} width={33} height={24} alt="DinersClub" />
    </div>
  )
}
